import React, { useEffect, useState } from 'react';
import { Collapse, Tag, message } from 'antd';
import { VARIABLES_BY_TYPE } from './mockData';
import { getAccessTokenApi } from 'api/auth';
import { getTenantTextsByDocumentTypeApi } from 'api/tenantText';

// Helper que muestra las variables disponibles como tags clickeables. Divide
// en 2 grupos colapsables:
//  1. Variables runtime (del budget/cliente/items) — listadas en
//     VARIABLES_BY_TYPE[documentType].
//  2. Textos del tenant — keys de tenant_texts para el documentType actual.
//     Se cargan del endpoint /tenants/:tenantId/texts/by-document-type
//     si el editor está en modo cross-tenant (tenantId prop). Si no, el grupo
//     no se muestra.
function VariablesHelper({ documentType, tenantId }) {
  const runtimeVars = VARIABLES_BY_TYPE[documentType] || [];
  const [tenantKeys, setTenantKeys] = useState([]);

  useEffect(() => {
    let alive = true;
    if (!tenantId || !documentType) {
      setTenantKeys([]);
      return;
    }
    (async () => {
      try {
        const token = await getAccessTokenApi();
        const result = await getTenantTextsByDocumentTypeApi(token, tenantId, documentType);
        if (!alive) return;
        if (Array.isArray(result)) {
          setTenantKeys(result.map((r) => r.keyName).filter(Boolean));
        }
      } catch {
        // silencioso — si falla, simplemente el grupo queda vacío/oculto.
      }
    })();
    return () => {
      alive = false;
    };
  }, [tenantId, documentType]);

  const copy = (v) => {
    const text = `{${v}}`;
    navigator.clipboard?.writeText(text);
    message.success(`Variable ${text} copiada`);
  };

  const items = [
    {
      key: 'runtime',
      label: `Variables runtime (${runtimeVars.length})`,
      children: (
        <div>
          <p style={{ marginTop: 0, marginBottom: 8, color: '#7f8c8d' }}>
            Datos del documento en runtime (budget, cliente, items). Haz click para copiar. Úsalas
            como <code>{'{nombre_variable}'}</code>.
          </p>
          {runtimeVars.length === 0 ? (
            <em>Sin variables para este tipo.</em>
          ) : (
            runtimeVars.map((v) => (
              <Tag
                key={v}
                color="green"
                style={{ cursor: 'pointer', marginBottom: 4 }}
                onClick={() => copy(v)}
              >
                {`{${v}}`}
              </Tag>
            ))
          )}
        </div>
      ),
    },
  ];

  if (tenantId) {
    items.push({
      key: 'tenant',
      label: `Textos del tenant (${tenantKeys.length})`,
      children: (
        <div>
          <p style={{ marginTop: 0, marginBottom: 8, color: '#7f8c8d' }}>
            Textos configurables por tenant (gestiónalos en el panel lateral). Haz click para
            copiar.
          </p>
          {tenantKeys.length === 0 ? (
            <em>
              Sin keys seedeadas para <code>{documentType}</code>.
            </em>
          ) : (
            tenantKeys.map((v) => (
              <Tag
                key={v}
                color="blue"
                style={{ cursor: 'pointer', marginBottom: 4 }}
                onClick={() => copy(v)}
              >
                {`{${v}}`}
              </Tag>
            ))
          )}
        </div>
      ),
    });
  }

  return <Collapse size="small" items={items} />;
}

export default VariablesHelper;
